import { _ } from "libs";

import React from "react";
import { Link } from "react-router-dom";

export default function NotInPlayerNetwork() {
	return (
		<div className="noResults">
			<h5>{_("players.notInThePlayerNetwork.heading")}</h5>
			<p>{_("onboarding.profileForm.playerNetwork.description")}</p>
			<p>
				<Link to="/settings/account" className="link">
					{_("playerNetwork.joinBtn")}
				</Link>
			</p>
		</div>
	);
}
